(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDialogController', TimeseriesDialogController);

    TimeseriesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Timeseries', 'Country', 'Frequency', 'TimeseriesData'];

    function TimeseriesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Timeseries, Country, Frequency, TimeseriesData) {
        var vm = this;

        vm.timeseries = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countries = Country.query();
        vm.frequencies = Frequency.query();
        vm.timeseriesdata = TimeseriesData.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.timeseries.id !== null) {
                Timeseries.update(vm.timeseries, onSaveSuccess, onSaveError);
            } else {
                Timeseries.save(vm.timeseries, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:timeseriesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
